import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AccountService } from '@app/services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class DashboardComponent implements OnInit {
  link_bi_marketing:any;
  link_bi_sales:any;
  constructor(private sanitizer: DomSanitizer, private accountservice: AccountService) {
    if(this.accountservice.userValue?.organization){
      this.link_bi_marketing = this.accountservice.userValue?.organization.link_bi_marketing;
      this.link_bi_sales = this.accountservice.userValue?.organization.link_bi_sales;
    }
   }

  ngOnInit(): void {
    console.log('user', this.accountservice.userValue);
    console.log('link mercadeo', this.link_bi_marketing);
    console.log('link ventas', this.link_bi_sales);
    if(this.link_bi_marketing=='') this.link_bi_marketing=null;
    if(this.link_bi_sales=='') this.link_bi_sales=null;
    
  }

  getBIMarketing(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.link_bi_marketing);
  }

  getBISales(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.link_bi_sales);
  }

}
